'use client'
import { useContext, useEffect, Suspense } from "react";
import Portfolio from "@/components/portfolioSection";
import Skills from "@/components/skills"
import Hero from "@/components/hero";
import AboutSection from "@/components/about";
import ParticlesComponent from "@/components/particles";
import Brands from "@/components/brands";
import ContactForm from "@/components/contactForm";
import NewsletterForm from "@/components/newsletterForm";
import ServicesArea from "@/components/servicesArea";
import { AnalyticsContext, AnalyticsProvider } from "../context/analyticsContext";

export default function Home() {

  const { trackEvent } = useContext(AnalyticsContext);

  useEffect(() => {
    trackEvent('view_homepage', {
      page_path: '/',
      page_title: document.title,
    });
  }, [trackEvent]);

  
  return (
    <main className="overflow-x-hidden">
      <Suspense>
      <AnalyticsProvider>
        <Hero />
        <AboutSection/>
        <ServicesArea />
        {/* <Skills skills={skills} /> */}
        <Portfolio />
        {/* <ParticlesComponent /> */}
        <Brands />
        <ContactForm />
        <NewsletterForm />
        {/* <MiniFooter /> */}
      </AnalyticsProvider>
      </Suspense>
    </main> 
  )
}
